import * as React from 'react';
import * as classNames from 'classnames';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import { PagesState } from '../../reducers/pages';
import { canMoveToPrev, canMoveToNext } from '../../helpers/pages';
import { AppStates, Publication, PageAction } from '../../../../..';

interface PageNavigatorProps {
  readonly dispatch: Dispatch<Action>;
  readonly pages: PagesState;
  readonly publication: Publication | undefined;
}

class PageNavigator extends React.PureComponent<PageNavigatorProps> {
  public render() {
    if (this.props.publication === undefined) {
      throw new Error('Unexpected state.');
    }

    const wrapperStyle: React.CSSProperties = {
      padding: '8px',
      background: 'rgba(192, 192, 192, 0.7)',
      position: 'absolute',
      bottom: '64px',
      left: '50%',
      marginLeft: '-90px',
    };

    const buttonStyle: React.CSSProperties = {
      display: 'inline-block',
      width: '36px',
      height: '36px',
      lineHeight: '36px',
      background: '#757575',
      color: '#fff',
      textAlign: 'center',
      textDecoration: 'none',
    };

    const { dispatch } = this.props;
    const { activeTab } = this.props.pages;
    const prevEnabled = canMoveToPrev(this.props.pages, this.props.publication);
    const nextEnabled = canMoveToNext(this.props.pages, this.props.publication);

    return (
      <div style={wrapperStyle}>
        <a href="#"
          onClick={() => { if (prevEnabled) PageAction.showPrevPage(activeTab, dispatch); }}
          className={classNames({ disabled: !prevEnabled })}
          style={buttonStyle}
          title="前へ"
          aria-label="Prev">&lt;</a>
        <span style={{ display: 'inline-block', width: '80px' }} />
        <a href="#"
          onClick={() => { if (nextEnabled) PageAction.showNextPage(activeTab, dispatch); }}
          className={classNames({ disabled: !nextEnabled })}
          style={buttonStyle}
          title="次へ"
          aria-label="Next">&gt;</a>
      </div>
    );
  }
}

const mapStateToProps = (appStates: AppStates) => {
  return {
    pages: appStates.pages,
    publication: appStates.publication,
  };
};

export default connect(mapStateToProps)(PageNavigator);
